import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  height: 435px;
  width: 100%;

  img {
    max-width: 100%;
    max-height: 550px;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto;
  }

  .active {
    animation: 0.5s fade-in;
    opacity: 1;

    @keyframes fade-in {
      from {
        opacity: 0;
      }

      to {
        opacity: 1;
      }
    }
  }

  .inactive {
    animation: 0.5s fade-out;
    opacity: 0;

    @keyframes fade-out {
      from {
        opacity: 1;
      }

      to {
        opacity: 0;
      }
    }
  }
`;

export { Container };
